import { render, staticRenderFns } from "./PresellList.vue?vue&type=template&id=354d127e&scoped=true&"
import script from "./PresellList.vue?vue&type=script&lang=js&"
export * from "./PresellList.vue?vue&type=script&lang=js&"
import style0 from "./PresellList.vue?vue&type=style&index=0&id=354d127e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d127e",
  null
  
)

export default component.exports